<template>
  <div class="aboutPage" id="tinyScreenAbout">
    <Header></Header>
    <!-- banner -->
    <div class="bannerBox">
      <div class="bannerPic  pcShow">
        <img :src="pcAdvertUrl">
      </div>
       <div class="bannerPhonePic phoneShow">
           <div class="pic" :style="{backgroundImage:'url('+mobileAdvertUrl+')'}">
             </div>
        </div>
    </div>
    <!-- section1 -->
    <div class="section1 middle">
      <div class="container">
        <h3>{{$t('about.about')}}</h3>
        <p v-html="content"></p>
      </div>
    </div>
    <!-- section2 -->
    <div class="section2 middle">
      <div class="container">
        <div class="box">
          <h6>{{$t('about.story')}}</h6>
          <h5>{{$t('about.stroySub')}}</h5>
          <div class="more" @click="goStory">{{$t('about.more')}}<i><img width="10px" src="../../assets/picture/occupation/right.png"></i></div>
        </div>
      </div>
    </div>
    <!-- section3 -->
    <div class="section3 middle">
      <div class="container" style="width: 1225px;">
        <h4 class="ml35">{{$t('about.facts')}}</h4>
        <el-carousel height="455px" class="pcShow">
        <el-carousel-item v-for="(item,index) in section3List" :key="index">
          <ul>
            <li v-for="(dot,num) in item.subPic" :key="num">
              <img @mouseenter="changePic(num,'hover')" :class="bannerIndex == num && isHover?'none':'block'" width="275px" height="345px" :src="dot.picUrl1">
              <img @mouseleave="changePic(num,'leave')" :class="bannerIndex == num && isHover?'block':'none'" width="275px" height="345px" :src="dot.picUrl2">
            </li>
          </ul>
        </el-carousel-item>
      </el-carousel>
      
      <el-carousel class="phoneShow picBox" ref="remarkCarusel" @change="lisChange" :initial-index="0" >
        <el-carousel-item v-for="(item,index) in section3PhoneList" :key="index">
          <div @touchstart="gotouchstart" @touchmove="gotouchmove" @touchend="gotouchend" class="picBn" :style="{backgroundImage:isLongPress == false?'url('+item.picUrl1+')':'url('+item.picUrl2+')'}"></div>    
        </el-carousel-item>  
      </el-carousel> 
      <span class="dot phoneShow"><i class="mr55" @click="prev"><img width="13px" src="../../assets/picture/about/left.png"></i>{{carouselIndex+1}} / {{section3PhoneList.length}}<i @click="next" class="ml55"><img width="13px" src="../../assets/picture/about/right.png"></i></span>
      </div>
    </div>
    <!-- section4 -->
    <div class="section4 middle">
      <div class="container">
        <h4>{{$t('about.work')}}</h4>
        <el-carousel height="250px" class="pcShow">
          <el-carousel-item v-for="(item,index) in section4List" :key="index">
            <ul>
              <li class="w24" v-for="(dot,num) in item.subPic" :key="num">
                <img width="100%" @click="goPage(dot)" :src="dot.picUrl1">
               <!--  <p class="txt">{{dot.name}}</p> -->
              </li>
            </ul>
          </el-carousel-item>
        </el-carousel>
        <el-carousel height="150px" class="phoneShow picBox">
          <el-carousel-item v-for="(item,index) in section4PhoneList" :key="index">
            <img :src="item.picUrl1" @click="goPage(item)">
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../common/header';
import Footer from '../common/footer';
export default {
  data() {
    return {
      pcAdvertUrl:'',
      mobileAdvertUrl:'',
      isLongPress:false,
      timeOutEvent:0,
      isHoverPhone:false,
      picIndex:-1,
      carouselIndex:0,
      content:'',
      bannerIndex:null,
      isShowSearch:false,
      elIndex:0,
      section3PhoneList:[
            {
              picUrl1:require('../../assets/picture/about/kp152.png'),
              picUrl2:require('../../assets/picture/about/kp1.52hover.png'),
            },
            {
              picUrl1:require('../../assets/picture/about/kp3.png'),
              picUrl2:require('../../assets/picture/about/kp3hover.png'),
            },
            {
              picUrl1:require('../../assets/picture/about/kp8.png'),
              picUrl2:require('../../assets/picture/about/kp8hover.png')
            },
            {
               picUrl1:require('../../assets/picture/about/kp34.png'),
               picUrl2:require('../../assets/picture/about/kp34hover.png'),
            },
            {
              picUrl1:require('../../assets/picture/about/kp47.png'),
              picUrl2:require('../../assets/picture/about/kp47hover.png'),
            },
            {
              picUrl1:require('../../assets/picture/about/kp59.png'),
              picUrl2:require('../../assets/picture/about/kp59hover.png'),
            },
            {
              picUrl1:require('../../assets/picture/about/kp76.png'),
              picUrl2:require('../../assets/picture/about/kp76hover.png'),
            },
      ],
      section3List:[
        {
          subPic:[
            {
              picUrl1:require('../../assets/picture/about/kp152.png'),
              picUrl2:require('../../assets/picture/about/kp1.52hover.png'),
            },
             {
              picUrl1:require('../../assets/picture/about/kp8.png'),
              picUrl2:require('../../assets/picture/about/kp8hover.png'),
            },
            {
              picUrl1:require('../../assets/picture/about/kp3.png'),
              picUrl2:require('../../assets/picture/about/kp3hover.png'),
            },
            {
              picUrl1:require('../../assets/picture/about/kp59.png'),
              picUrl2:require('../../assets/picture/about/kp59hover.png'),
            },
          ],
        },
         {
          subPic:[
            {
              picUrl1:require('../../assets/picture/about/kp59.png'),
              picUrl2:require('../../assets/picture/about/kp59hover.png'),
            },
            {
              picUrl1:require('../../assets/picture/about/kp47.png'),
              picUrl2:require('../../assets/picture/about/kp47hover.png'),
            },
            {
               picUrl1:require('../../assets/picture/about/kp34.png'),
              picUrl2:require('../../assets/picture/about/kp34hover.png'),
            },            
            {
              picUrl1:require('../../assets/picture/about/kp76.png'),
              picUrl2:require('../../assets/picture/about/kp76hover.png'),
            },
          ],
        }
      ],
      section4PhoneList:[],
      section4List:[
        {
          subPic:[],
        },
        {
          subPic:[],
        },
      ],
      isHover:false,
    };
  },
  components: { Header,Footer },
  mounted(){
      this.getJiaQiTouzi();
      this.getAdvert();
      this.getWorkAdvert();
  },
  methods: {
  // 获取关于佳期
    async getJiaQiTouzi() {
        const { data: res } = await this.$http.get("/article/getAboutJiaQi.do");
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        this.content = res.data.content;
    },
    goStory(){
       this.$router.push({  
            path: '/story'  
        }) 
    },
    lisChange(index) {
         this.carouselIndex = index;
    },
    prev(){
      this.$refs.remarkCarusel.setActiveItem(this.carouselIndex-1);
      // this.refs.remarkCarusel.prev();
    },
    next(){
      this.$refs.remarkCarusel.setActiveItem(this.carouselIndex+1);
    },
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
    // 工作在佳期广告图点击
    goPage(item){
      if(item.url){
        this.$router.push({  
          path: item.url  
        })
      }
    },
    changePic(num,way){
      if(way == 'hover'){
        this.isHover = true;
      }else{
        this.isHover = false;
      }
      this.bannerIndex = num;
    },
    gotouchstart(){
      let that = this;
      clearTimeout(that.timeOutEvent);//清除定时器
      that.timeOutEvent = 0;
      that.timeOutEvent = setTimeout(function(){
           //执行长按要执行的内容，
          that.isLongPress = true;
         },600);//这里设置定时
    },
    //手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
    gotouchend(){
        clearTimeout(this.timeOutEvent);
          if(this.imeOutEvent!=0){
            this.isLongPress = false;
         }
    },
    //如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按 
    gotouchmove(){
         clearTimeout(this.timeOutEvent);//清除定时器
         this.timeOutEvent = 0;
         this.isLongPress = false;
    },
    // 根据埋点ID及非必填项获取广告位
    async getAdvert() {
        const { data: res } = await this.$http.get("/advert/getAdvert.do?pointId=3");
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        this.pcAdvertUrl = res.data[0].pcAdvertUrl;
        this.mobileAdvertUrl = res.data[0].mobileAdvertUrl;
    },
    // 根据埋点ID及非必填项获取广告位-工作在佳期
    async getWorkAdvert() {
        const { data: res } = await this.$http.get("/advert/getAdvert.do?pointId=16");
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        let pcUrl = [];
        let phoneUrl = [];
        let urlList = [];
        pcUrl = res.data[0].pcAdvertUrl.split(',');
        phoneUrl = res.data[0].mobileAdvertUrl.split(',');
        urlList = res.data[0].url.split(',');
        for (var i = 0; i < pcUrl.length; i++) { 
          let pcItem = {
            picUrl1:pcUrl[i],
            url:urlList[i]
          }
          if(i<4){
            this.section4List[0].subPic.push(pcItem);
          }else{
            this.section4List[1].subPic.push(pcItem);
          }
        }
        for (var i = 0; i < phoneUrl.length; i++) { 
          let phoneItem = {
            picUrl1:phoneUrl[i],
            url:urlList[i]
          }
          this.section4PhoneList.push(phoneItem);
        }
    },
  }
};
</script>

<style lang="less" scoped>
.aboutPage{
  /*********************************************/
  .bannerBox{    
     width:100%;  
     position:relative;  
     overflow:hidden;  
     height:620px; 
  .bannerPic{
      /*width:auto;
      height:100%;
      display:flex;
      align-items:center; 
      justify-content:center;*/
       width:1920px; /*图片宽度*/  
       position:absolute;  
       left:50%;  
       margin-left:-960px; /*图片宽度的一半*/  
    }
    .bannerPhonePic{
       .pic{
          width: 100%;
          height: 620px;
          padding-top: 240px;
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
          background-image: url(../../assets/picture/homePic/phone/bannerHome.png);
          img{
           display: block;
           margin:0 auto;
          }
       } 
    }
  }
  /************************************************/
  .section1{
    padding:120px 0 85px;
    padding-top: 70px;
    h3{
      text-align: center;
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #900211;
      line-height: 36px;
      letter-spacing: 5px;
    } 
    p{
      width: 1008px;
      display: block;
      margin:0 auto;
      margin-top: 36px;
      font-size: 24px;
      font-family: PingFangSC-Thin, PingFang SC;
      font-weight: 100;
      color: #333333;
      line-height: 44px;
      letter-spacing: 1px;
      text-align: center;
    }
    /deep/ span{
      background: none!important;
    }
  }
  /**************************************************/
  .section2{
    .container{      
      padding-bottom: 70px;
      border-bottom: 1px solid #D5D5D5;      
      .box{
        height: 400px;
        background-image: url(../../assets/picture/about/p3.png);
        background-size: cover;
        h6{
        margin:104px 0 14px 50px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #D8D8D8;
        line-height: 37px;
        display: inline-block;
      }
      h5{
        margin-left: 50px;
        margin-bottom: 101px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #F2F2F2;
        line-height: 22px;
      }
      .more{
        width: 130px;
        height: 44px;
        border: 1px solid #F2F2F2;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #F2F2F2;
        line-height: 44px;
        text-align: center;
        margin-left: 50px;
        cursor: pointer;
      }
      }
    }
  }
  /******************************************************/
  .section3{
    padding: 48px 0 55px 0;
    img{
      pointer-event:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;
    }
    /deep/ .el-carousel__arrow--right{
      right: -4%;
      top:38%;
      display: none;
    }
     /deep/ .el-carousel__arrow--left{
      left: -4%;
      top:38%;
      display: none;
    }
    /deep/ .el-carousel__indicator--horizontal{
      padding:12px !important;
    }
    /deep/ .el-carousel__indicators--horizontal{
      bottom: 55px !important;
      padding:0 24px;
    }
    /deep/ .el-carousel__button{

    }
    /deep/ .el-carousel__arrow i{
      color: #900211;
      font-size: 25px;
    }
    /deep/ .el-carousel--horizontal {
      overflow-x: hidden;
      padding: 0 35px;
    }
    h4{      
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #900211;
      line-height: 42px;
      margin-bottom: 52px;
    }
    ul{
      width: 100%;
      li{
        float: left;
        margin-right: 13px;
        overflow: hidden;
        cursor: pointer;
      }
      li:last-of-type{
        margin-right: 0;
      }
    }
    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 150px;
        margin: 0;
    }
    /deep/ .is-active{
      .el-carousel__button{
      width: 180px !important;
      height: 3px;
      background: #900211 !important;
        }
      }
     /deep/ .el-carousel__button{
     width: 180px !important;
     height: 3px;
     background: #454545 !important;
    }
  }
  /******************************************************/
  .section4{
    background: #F0F0F2;
    padding: 48px 0 120px 0;
     /deep/ .el-carousel__arrow{
      top:auto !important;
      bottom: 35px !important;
      display: none !important;
      background: none;
    }
    h4{      
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #900211;
      line-height: 42px;
      margin-bottom: 52px;
    }
    ul{
      width: 100%;
      li{
        float: left;
        margin-right: 13px;
        overflow: hidden;
        cursor: pointer;
      }
      li:last-of-type{
        margin-right: 0;
      }
    }
    .txt{
      margin-top: 21px;
      margin-bottom: 60px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9A9A9A;
      line-height: 22px;
    }
    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 150px;
        margin: 0;
    }
    /deep/ .is-active{
      .el-carousel__button{
      width: 20px !important;
      height: 3px;
      background: #900211 !important;
        }
      }
     /deep/ .el-carousel__button{
     width: 20px !important;
     height: 3px;
     background: #454545 !important;
    }
  }
}
</style>
